import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/indeterminate.svg';

export const IconIndeterminate = createIconComponent(Icon);
